import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetItemListHeader: {
    minHeight: theme.spacing(5),
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.background.default,
    borderRadius: '10px 10px 0 0',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },

  trainingSetItemList: {
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: '10px',
    overflow: 'hidden',
    margin: theme.spacing(0, 1, 1),
  },
  headerTextWrapper: {
    minWidth: 0,
    textTransform: 'capitalize',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    padding: theme.spacing(0, 0.5, 0, 0),
  },
  fireIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.warning.main,
  },
}));
